import { useRef } from 'react';
import type { AppliedDashboardFilters } from './filterParams';

/** Following the URL would blank the dashboard on every edit. Undefined holds the first render back. */
export const useRenderedFilters = (applied: AppliedDashboardFilters): AppliedDashboardFilters | undefined => {
  const lastApplied = useRef<AppliedDashboardFilters | undefined>(undefined);
  if (applied.isApplied) lastApplied.current = applied;
  return lastApplied.current;
};
